module.exports = __webpack_public_path__ + "static/img/zhwb.4072232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/zhwb.png
// module id = uzAO
// module chunks = 9